import axios from 'axios'

export const parseCookies = (cookieString = '') => {
  return cookieString
    .split(';')
    .filter(Boolean)
    .reduce((cookies, cookie) => {
      const [name, ...rest] = cookie.split('=')
      cookies[name.trim()] = decodeURIComponent((rest || []).join('=').trim())
      return cookies
    }, {})
}

export const mapFeedbackData = (feedbackParams = {}) => {
  const cookiesObj = typeof document !== 'undefined' ? parseCookies(document.cookie) : {}

  const filteredCookies = Object.fromEntries(
    Object.entries(cookiesObj).filter(([key]) => key.startsWith('i_') || key.startsWith('mp_'))
  )

  feedbackParams.clickData = {
    ...filteredCookies,
  }

  if (cookiesObj['i_clickId'] || cookiesObj['clickId'] || cookiesObj['clickid']) {
    feedbackParams.clickId = cookiesObj['i_clickId'] || cookiesObj['clickId'] || cookiesObj['clickid']
  }

  return feedbackParams
}

export const sendFeedbackV2 = async (feedbackParams) => {
  try {
    const response = await axios.post('https://feedback.intego.com/v2/feedback', feedbackParams, {
      headers: { 'Content-Type': 'application/json' },
    })

    if (typeof document !== 'undefined') {
      if (response.data && response.data.clickData) {
        Object.entries(response.data.clickData).forEach(([key, value]) => {
          document.cookie = `i_${key}=${value}; path=/; domain=.intego.com; max-age=${30 * 24 * 60 * 60}`
        })
      }
      if (response.data && response.data.clickId) {
        document.cookie = `i_clickId=${response.data.clickId}; path=/; domain=.intego.com; max-age=${30 * 24 * 60 * 60}`
      }
    }

    return response
  } catch (error) {
    console.error('Error sending feedback:', error)
    throw error
  }
}

export const callFeedbackOnPage = async () => {
  if (typeof window === 'undefined') {
    return
  }

  const feedbackParams = mapFeedbackData({})

  try {
    await sendFeedbackV2(feedbackParams)
  } catch (error) {
    console.error('callFeedbackOnPage error:', error)
  }
}
